/**
 * 申报主体基本信息
 */
import { any } from 'prop-types';
import DictionaryMatching from '@/components/DictionaryMatching/DictionaryMatching';
import { LGG_ACCOUNT_TYPE, LGG_MANAGER_TYPE } from '@/utils/mappingDict';

function SubjectBasicInfo({ data, dict }) {
  return (
    <>
      <div className="myapplication-detail__sub-tiny-title">申报主体基本信息</div>
      <div className="manage-detail_basic" style={{ marginBottom: 20 }}>
        <div className="myapplication-detail__grid">
          <div>
            姓名/单位：
            {data?.applicantName}
          </div>
          <div>
            身份证号/机构代码：
            {data?.applicantNo}
          </div>
          <div>
            注册地点/户籍所在地：
            {data?.provinceCode}
            -
            {data?.cityCode}
            -
            {data?.areaCode}
          </div>
          <div>
            联系地址：
            {data?.detailAddress}
          </div>
          <div>
            经营主体类型：
            <DictionaryMatching value={data?.managementEntityType} dictionary={dict[LGG_MANAGER_TYPE]} />
          </div>
          <div>
            申报年度：
            {data?.applicationYear}
          </div>
          <div>
            联系人：
            {data?.contactor}
          </div>
          <div>
            联系电话：
            {data?.telephone}
          </div>
          <div>
            开户银行：
            {data?.depositBank}
          </div>
          <div>
            银行卡账号：
            {data?.bankCardAccount}
          </div>
          <div>
            账户类型：
            <DictionaryMatching value={data?.accountType} dictionary={dict[LGG_ACCOUNT_TYPE]} />
          </div>
        </div>
        <div className="myapplication-detail__grid24">
          <div>备注：</div>
          <div>{data?.remark}</div>
        </div>
      </div>
    </>
  );
}

export default SubjectBasicInfo;

SubjectBasicInfo.propTypes = {
  data: any,
  dict: any,
};
